<template>
  <div class="outter-modal">
    <div class="modal fade show" style="display: block; overflow: scroll" tabindex="-1" @click="onClose">
      <div class="modal-dialog modal-md modal-dialog-centered" @click.stop="">
        <div class="modal-content">
          <div class="modal-header">
            <span>Suggest price &mdash; Lead #{{ lead.id }}</span>
            <button @click="onClose" type="button" class="close" aria-label="Close">&times;</button>
          </div>
          <div class="modal-body">
            <p class="mb-2">
              <span v-if="vehicle">
                <b>{{ vehicle.year }}</b> {{ vehicle.make }} {{ vehicle.model }}
                <span v-if="vehicle.vehicleType"> ({{ vehicle.vehicleType.name }})</span>
              </span>
              <br />
              <span class="text-muted"> Current calculated (STD): {{ lead.priceStd ? priceFormat(lead.priceStd) : '-' }} </span>
            </p>

            <div v-if="previous.length" class="form-group">
              <label class="mb-1">Your previous suggestions for this route</label>
              <ul class="list-unstyled mb-0 small">
                <li v-for="p in previous" :key="p.id">
                  <b>{{ priceFormat(p.suggestedPrice) }}</b>
                  <span v-if="p.reason" class="text-muted">&mdash; {{ p.reason }}</span>
                  <span class="text-muted"> ({{ p.createdAt | formatDateTime }})</span>
                </li>
              </ul>
            </div>

            <ValidatedInput id="suggestedPrice" mask="price" label="Suggested price" v-model="suggestedPrice" />

            <div class="form-group">
              <label>Reason <span class="text-danger">*</span></label>
              <textarea v-model="reason" class="form-control" rows="3" maxlength="500" placeholder="Why is the calculated price wrong?" />
            </div>

            <div v-if="error" class="alert alert-danger py-2">{{ error }}</div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="onClose">Cancel</button>
            <button type="button" class="btn btn-primary" :disabled="saving || !suggestedPrice || !reason.trim()" @click="submit">{{ saving ? 'Saving…' : 'Submit' }}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop" />
  </div>
</template>

<script>
import { ApiClient } from '@/api/ApiClient';
import ValidatedInput from '@/components/shared/ValidatedInput';

export default {
  name: 'LeadsCardSuggestedPriceModal',
  components: {
    ValidatedInput,
  },
  props: {
    lead: { type: Object, required: true },
    onClose: { type: Function, default: () => {} },
  },
  data() {
    return {
      suggestedPrice: '',
      reason: '',
      saving: false,
      error: '',
      previous: [],
    };
  },
  computed: {
    vehicle() {
      return this.lead.vehicles[0] || null;
    },
    currentUserId() {
      return this.$store.state.auth.user?.id;
    },
  },
  mounted() {
    this.fetchPrevious();
  },
  methods: {
    async fetchPrevious() {
      const response = await ApiClient.leads.suggestedPrices.get({
        params: { leadId: this.lead.id },
      });
      if (response.status === 200) {
        const rows = response.data?.data || [];
        this.previous = rows.filter(p => p.user && p.user.id === this.currentUserId);
      }
    },
    async submit() {
      const vehicleTypeId = this.vehicle?.vehicleType?.id;
      if (!vehicleTypeId || !this.suggestedPrice || !this.reason.trim()) return;
      this.saving = true;
      this.error = '';
      const response = await ApiClient.leads.suggestedPrices.post({
        leadId: this.lead.id,
        body: {
          vehicleTypeId,
          suggestedPrice: Math.round(Number(this.suggestedPrice)),
          reason: this.reason.trim(),
        },
      });
      this.saving = false;
      if (response.status === 200 || response.status === 201) {
        this.$emit('saved', response.data?.data);
        this.onClose();
      } else if (response.status === 403) {
        this.error = 'You are not allowed to suggest a price.';
      } else if (response.status === 422) {
        const first = response.data.errors ? Object.values(response.data.errors)[0] : null;
        this.error = (first && first[0]) || 'Validation failed';
      } else if (response.status === 400) {
        this.error = response.data.message || 'Submit failed';
      } else {
        this.error = 'Unexpected error';
      }
    },
    priceFormat(price) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });
      return formatter.format(price);
    },
  },
};
</script>

<style lang="scss" scoped>
.outter-modal {
  position: absolute;
  z-index: 1089;
}
</style>
